import { render } from "./DocumentModal.vue?vue&type=template&id=5f6bfcec&scoped=true"
import script from "./DocumentModal.vue?vue&type=script&lang=js"
export * from "./DocumentModal.vue?vue&type=script&lang=js"

import "./DocumentModal.vue?vue&type=style&index=0&id=5f6bfcec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5f6bfcec"

export default script